import InventoryScreen from './InventoryScreen.jsx';

export default {
  path: '/inventory',
  element: <InventoryScreen />,
  protected: true,
  anyPermission: ['inventory.view', 'inventory.stock_report.view'],
  standalone: false,
  sidebar: { label: 'المخزون', icon: 'inventory', group: 'inventory', order: 70 }
};
